module.exports = "../../../../platform/assets/pageMainIcon/icon-shuzhi-2-yellow.svg";